import {
    Directive,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ElementRef
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
declare var $: any;
@Directive({
    selector: 'button, input[type=button], [appDebounceClick]'
})
export class DebounceClickDirective implements OnInit, OnDestroy {
    @Input()
    debounceTime = 700;
    @Input()
    notDebounce = false;

    @Output()
    debounceClick = new EventEmitter();

    private clicks = new Subject();
    private subscription: Subscription;

    constructor(private _el: ElementRef) { }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    @HostListener('click', ['$event'])
    clickEvent(event) {
        if (!this.notDebounce)  {
            this._el.nativeElement.disabled = true;
            // event.preventDefault();
            // event.stopPropagation();
            this.clicks.next(event);
            setTimeout(() => {
                this._el.nativeElement.disabled = false;
            }, this.debounceTime)
        }

    }

}
